import { Route, Routes } from "react-router-dom"
import TravelersCheckList from "./components/TravelersCheckList"

export default function TravelersChecksPage() {
  return (
    <Routes>
      <Route index element={<TravelersCheckList />} />
      <Route path=":id" element={<TravelersCheckList />} />
    </Routes>
  )
}
